import { Pipe, PipeTransform } from "@angular/core";
import { I18nPipe } from "./i18n.pipe";

@Pipe({
    name: "i18nStepStatus",
    pure: false // required to update the value when the promise is resolved
    ,
    standalone: false
})
export class I18nStepStatusPipe extends I18nPipe implements PipeTransform {
  public transform(value: unknown, ...args: unknown[]): unknown {
    return super.transform(`status_step_${value}`, ...args);
  }
}
